"use client";

import { Button } from "@modernatc/ui/button";
import { Callsign } from "@modernatc/ui/callsign";

interface ErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

export default function GlobalError({ error, reset }: ErrorProps) {
  return (
    <main className="mx-auto flex min-h-screen max-w-3xl flex-col items-start justify-center gap-6 px-4 py-24 sm:px-6">
      <Callsign className="text-callsign text-2xl text-[var(--color-critical)]">⚠ MAYDAY</Callsign>
      <h1 className="text-balance text-4xl font-semibold tracking-tight text-[var(--color-ink)]">
        Something broke mid-session.
      </h1>
      <p className="text-pretty text-lg text-[var(--color-ink-dim)]">
        Your last review was saved. Try the action again or head back to
        the dashboard.
      </p>
      {error.digest ? (
        <p className="text-callsign text-xs text-[var(--color-ink-muted)]">
          Reference: {error.digest}
        </p>
      ) : null}
      <div className="flex flex-wrap gap-3">
        <Button onClick={reset} size="lg" variant="primary">
          Try again
        </Button>
        <Button asChild size="lg" variant="secondary">
          <a href="/dashboard">Dashboard</a>
        </Button>
      </div>
    </main>
  );
}
